const colorList = {
  ACTIVE: "rgb(197, 242, 199)",
  INACTIVE: "rgb(255, 245, 232)",
  PROCESSED: "rgb(255, 245, 232)",
  UNPROCESSED: "rgb(255, 245, 232)",
  DONOTUSE: "rgb(245, 84, 84)",
  PLSC: "rgb(230, 247, 255)",
  SITEOPEN: "rgb(255, 245, 232)",
  WORKATICKETS: "rgb(227 225 225)"
};

// TODO: extract this to somewhere else since it is being used by various components
export const getColor = type => {
  switch (type) {
    case "ACTIVE":
      return colorList.ACTIVE;
    case "INACTIVE":
      return colorList.INACTIVE;
    case "PAY_TIER":
      return colorList.PLSC;
    case "WARNING":
      return colorList.UNPROCESSED;
    case "WARNING_SERIOUS":
      return colorList.DONOTUSE;
    case "SUPPLIER":
      return colorList.WORKATICKETS;
    case "INFO":
      return colorList.WORKATICKETS;
    default:
      return colorList.WORKATICKETS;
  }
};

export const getCandidateProfilesColor = type => {
  switch (type) {
    case "Active":
      return colorList.ACTIVE;
    case "Inactive":
      return colorList.INACTIVE;
    case "Unprocessed":
      return colorList.UNPROCESSED;
    case "Processed":
      return colorList.PROCESSED;
    case "DoNotUse":
      return colorList.DONOTUSE;
    case "payment_tier":
      return colorList.PLSC;
    case "service_company":
      return colorList.PLSC;
    default:
      return colorList.PLSC;
  }
};
